import { OnInit, ElementRef } from '@angular/core';
import { MenuService } from './menu.service';
import { LinksService } from '../links/links.service';
import { UiService } from '../ui/ui.service';
var MenuComponent = /** @class */ (function () {
    function MenuComponent(menu, elementRef, linksService, ui) {
        var _this = this;
        this.menu = menu;
        this.elementRef = elementRef;
        this.ui = ui;
        this.opened = false;
        this.links = [];
        var el = elementRef.nativeElement;
        var l = el.classList;
        this.menu.state$.subscribe(function (b) { return _this.opened = b; });
        this.menu.state$.subscribe(function (b) { return b ? l.add('opened') : l.remove('opened'); });
        this.ui.accentuated$.subscribe(function (b) { return b ? l.remove('whitened') : l.add('whitened'); });
        this.links = linksService.links.filter(function (l) { return !l.only || l.only.indexOf('menu') !== -1; });
        ;
    }
    MenuComponent.prototype.ngOnInit = function () {
    };
    return MenuComponent;
}());
export { MenuComponent };
//# sourceMappingURL=menu.component.js.map